"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentItemFile = void 0;
var _api = require("../../models/api");
var _DocumentState = require("../Document/DocumentState");
var _DocumentItemStyledComponents = require("./DocumentItemStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const bytesInKb = 1024;
const DocumentItemFile = props => {
  const {
    document,
    visibleApprovalState
  } = props;
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const customerId = registrationData?.customerId ?? null;
  const documentItemUrl = (0, _api.useCustomerDocument)(customerId, document.documentId);
  const handleDownloadDocument = event => {
    const link = event.target;
    if (!link.href) {
      event.preventDefault();
      const documentUrl = documentItemUrl ?? '';
      if (documentUrl !== '') {
        link.href = documentUrl;
        link.click();
      }
    }
  };
  const getDocumentItemLink = () => {
    const {
      fileName,
      documentId
    } = document;
    if (fileName && documentId && documentId < 0) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledSpanFileName, {
        children: fileName
      });
    }
    if (fileName) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledSpanFileNameLink, {
        onClick: handleDownloadDocument,
        children: fileName
      });
    }
    return null;
  };
  const getDocumentSize = () => {
    const {
      fileSize
    } = document;
    const hundred = 100;
    const size = Math.round((fileSize ? fileSize / bytesInKb / bytesInKb : 0) * hundred) / hundred;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledSpanFileSize, {
      children: [size, " MB"]
    });
  };
  const getApprovalState = approval => {
    if (visibleApprovalState) {
      // if there is no approval information in document data,
      // it is automatically in "Pending" state
      let approvalState = 'Pending';
      let approvalReason;
      if (approval?.approvalState) {
        const {
          approvalState: state,
          reason
        } = approval;
        approvalState = state;
        approvalReason = reason;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentState.DocumentState, {
        state: approvalState,
        reason: approvalReason
      });
    }
    return null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledSpanFile, {
    children: [getDocumentItemLink(), getDocumentSize(), getApprovalState(document.approval)]
  });
};
exports.DocumentItemFile = DocumentItemFile;